import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../service/api/api.service';
import { Router } from '@angular/router';
import { AvatarModule } from 'ngx-avatar-2';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
interface PendingUser {
  id_utilisateur: number;
  prenom: string;
  nom: string;
  email?: string;
  telephone?: string;
  date_naissance?: string;
  annee_debut_conduite?: number;
  adresse?: string;
  photo_profil?: string;
}

@Component({
  selector: 'app-devenir',
  standalone: true,
  imports: [CommonModule, FormsModule, AvatarModule],
  templateUrl: './devenir.component.html',
  styleUrl: './devenir.component.scss'
})
export class DevenirComponent implements OnInit {
  user: any = null;
  showButton: boolean = false;
  showWaiting: boolean = false;
  showSuccess: boolean = false;   // Nouveau : message de succès après soumission
  loading: boolean = false;
  isAdmin: boolean = false;
  pendingUsers: PendingUser[] = [];
  loadingPending: boolean = false;
  loadingUser: boolean = false;

  constructor(
    public api: ApiService,
    private router: Router,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.user = this.api.token?.user_connected;
    if (!this.user) {
      this.router.navigate(['/login']);
      return;
    }

    this.isAdmin = this.user.id_privilege === 1;

    if (this.isAdmin) {
      this.loadPendingRequests();
    } else {
      this.refreshUserStatus();
    }
  }

  private refreshUserStatus(): void {
    this.loadingUser = true;
    this.api.taf_post('utilisateur/get', {
      id_utilisateur: this.user.id_utilisateur
    }, (reponse: any) => {
      if (reponse.status && reponse.data.length > 0) {
        this.user = { ...this.user, ...reponse.data[0] };
        this.api.token.user_connected = this.user;
        this.updateClientUI();
      }
      this.loadingUser = false;
    }, (error: any) => {
      console.error('Erreur refresh utilisateur:', error);
      this.updateClientUI();
      this.loadingUser = false;
    });
  }

  private updateClientUI(): void {
    this.showButton = this.user.id_privilege === 3 && this.user.id_statut_utilisateur !== 3;
    this.showWaiting = this.user.id_privilege === 3 && this.user.id_statut_utilisateur === 3;
  }

  loadPendingRequests(): void {
    this.loadingPending = true;
    this.api.taf_post('utilisateur/get', {
      id_privilege: 3,
      id_statut_utilisateur: 3
    }, (reponse: any) => {
      if (reponse.status) {
        this.pendingUsers = reponse.data;
      } else {
        this.api.Swal_error('Échec du chargement des demandes.');
      }
      this.loadingPending = false;
    }, (error: any) => {
      this.api.Swal_error('Erreur de connexion.');
      this.loadingPending = false;
    });
  }

  demanderPartenaire(): void {
    this.api.Swal_confirm(
      'Devenir partenaire',
      `Voulez-vous vraiment soumettre une demande pour devenir partenaire ? Vos informations seront vérifiées par un administrateur.`,
      () => {
        this.submitDemande();
      }
    );
  }

  private submitDemande(): void {
    this.loading = true;
    const payload = {
      condition: { id_utilisateur: this.user.id_utilisateur },
      data: {
        id_statut_utilisateur: 3
      }
    };

    this.api.taf_post('utilisateur/edit', payload, (reponse: any) => {
      if (reponse.status) {
        this.api.Swal_success('Demande soumise ! Elle est en attente de validation.');
        this.user.id_statut_utilisateur = 3;
        this.api.token.user_connected = { ...this.user };
        this.showButton = false;
        this.showWaiting = true;
        this.showSuccess = true; // Afficher le succès
      } else {
        this.api.Swal_error('Échec de la soumission de la demande.');
      }
      this.loading = false;
    }, (error: any) => {
      this.api.Swal_error('Erreur de connexion.');
      this.loading = false;
    });
  }

  annulerDemande(): void {
    this.api.Swal_confirm(
      'Annuler la demande',
      'Voulez-vous annuler votre demande de partenariat ?',
      () => {
        this.loading = true;
        const payload = {
          condition: { id_utilisateur: this.user.id_utilisateur },
          data: {
            id_statut_utilisateur: 1
          }
        };

        this.api.taf_post('utilisateur/edit', payload, (reponse: any) => {
          if (reponse.status) {
            this.api.Swal_success('Demande annulée avec succès.');
            this.user.id_statut_utilisateur = 1;
            this.api.token.user_connected = { ...this.user };
            this.showButton = true;
            this.showWaiting = false;
            this.showSuccess = false;
          } else {
            this.api.Swal_error('Échec de l\'annulation.');
          }
          this.loading = false;
        }, (error: any) => {
          this.api.Swal_error('Erreur de connexion.');
          this.loading = false;
        });
      }
    );
  }

  validerDemande(pendingUser: PendingUser): void {
    this.api.Swal_confirm(
      'Valider la demande',
      `Valider la demande de ${pendingUser.prenom || ''} ${pendingUser.nom} ? Il deviendra partenaire.`,
      () => {
        this.performAction(pendingUser, { id_statut_utilisateur: 1, id_privilege: 2 });
      }
    );
  }

  rejeterDemande(pendingUser: PendingUser): void {
    this.api.Swal_confirm(
      'Rejeter la demande',
      `Rejeter la demande de ${pendingUser.prenom || ''} ${pendingUser.nom} ?`,
      () => {
        this.performAction(pendingUser, { id_statut_utilisateur: 1 });
      }
    );
  }

 private performAction(pendingUser: PendingUser, data: any): void {
  this.loading = true;

  const payload = {
    condition: { id_utilisateur: pendingUser.id_utilisateur },
    data: data
  };

  this.api.taf_post('utilisateur/edit', payload, (reponse: any) => {
    this.loading = false;

    if (reponse.status) {
      this.api.Swal_success('Action effectuée avec succès !');

      // enlève juste du tableau local
      this.pendingUsers = this.pendingUsers.filter(
        u => u.id_utilisateur !== pendingUser.id_utilisateur
      );

      // notifier le parent
      this.activeModal.close({
        refresh: true
      });

    } else {
      this.api.Swal_error("Échec de l'action.");
    }
  }, () => {
    this.loading = false;
  });
}
}
